import { render, staticRenderFns } from "./ClaimsButton.vue?vue&type=template&id=fde22d20"
import script from "./ClaimsButton.vue?vue&type=script&lang=ts"
export * from "./ClaimsButton.vue?vue&type=script&lang=ts"
import style0 from "./ClaimsButton.vue?vue&type=style&index=0&id=fde22d20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports